import React, { useEffect, ReactElement } from 'react';
import Helmet from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Button,
  LinearProgress,
} from '@material-ui/core';

import { TableBox } from 'retired/Box';
import { selectUser } from 'entities/user/selectors';
import Location from 'entities/location/model';
import { useInjectEpics } from 'utils/injectEpics';
import { useInjectReducer } from 'utils/injectReducer';
import OrganizationMenu from 'retired/OrganizationMenu';

import { selectLoading } from './selectors';
import * as Actions from './actions';
import epics from './epics';
import reducer from './reducers';

const key = 'locationsPage';

const LocationsListPage = (): ReactElement => {
  const history = useHistory();
  const user = useSelector(selectUser);
  const loading = useSelector(selectLoading);
  const locations = user?.organization?.locations;
  const sortedLocations = locations?.sort((a: Location, b: Location) => {
    if (a.get('region') !== b.get('region')) {
      return a.get('region').localeCompare(b.get('region'));
    }
    if (a.get('country') !== b.get('country')) {
      return a.get('country').localeCompare(b.get('country'));
    }
    return a.get('name').localeCompare(b.get('name'));
  });
  const dispatch = useDispatch();
  useInjectReducer({ key, reducer });
  useInjectEpics({ key, epics });

  useEffect(() => {
    dispatch(Actions.initAction());
  }, []);

  if (user && (!user.isAdmin || !user.organization?.isCompany())) {
    history.replace('/');
  }
  return (
    <>
      <Helmet title="Company Locations" />
      <div
        style={{
          display: 'flex',
          marginBottom: 35,
        }}
      >
        <div>
          <OrganizationMenu />
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <Link to="/locations/new">
            <Button size="large">Add new location</Button>
          </Link>
        </div>
      </div>
      <div style={{ display: 'table', width: '100%' }}>
        <TableBox>
          {loading ? <LinearProgress /> : <div style={{ height: 4 }} />}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell size="medium">Name</TableCell>
                <TableCell size="medium">Country</TableCell>
                <TableCell size="medium">State</TableCell>
                <TableCell size="medium">Region</TableCell>
                <TableCell size="medium">Currency Code</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedLocations
                ?.map((location: Location) => (
                  <TableRow key={location.id}>
                    <TableCell>
                      <Link to={`/locations/${location.id}`}>{location.name}</Link>
                      {location.public && ' (Public)'}
                    </TableCell>
                    <TableCell>{location.country || location.countryCode}</TableCell>
                    <TableCell>{location.state || location.stateCode}</TableCell>
                    <TableCell>{location.region}</TableCell>
                    <TableCell>{location.currencyCode}</TableCell>
                  </TableRow>
                ))
                .toArray()}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={100} style={{ color: '#0000008a', fontSize: '0.875rem' }}>
                  Total: {locations?.size || 0}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableBox>
      </div>
    </>
  );
};

export default LocationsListPage;
